import { IonButton, IonModal } from "@ionic/react";
import React from "react";
import "./DnrPopup.scss";
import { useTranslation } from "react-i18next";

interface DNRPopupProps {
  showModal: boolean;
  onCancel: (data: boolean) => void;
  rowData: any;
  selectedCareTeamDetails: any;
}

const DNRPopup: React.FC<DNRPopupProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  return (
    <div>
    <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="dnr-modal"
      >
        <div className="dnr-cont">
          <div className="dnr-header">
            {t("dnrTitle")}
          </div>

          <div className="dnr-confirmation-text">
            {t("dnrConfirmation")}
          </div>

          <div className="dnr-btn-cont">
            <IonButton
              className="btn dnr-cancel-btn"
              onClick={() => props.onCancel(false)}
            >
              <span>{t("cancel")}</span>
            </IonButton>

            <IonButton
              className="btn dnr-send-btn"
              onClick={() => props.onCancel(true)}
            >
              {t("confirm")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </div>
  );
};
export default DNRPopup;
